/**
 * Cache un élément quand la touche echap est relachée et l'affiche quand ni'importe quelle touche est relachée.
 *
 * @param {string} elementSelector Le sélecteur de l'élements
 * @param {string} elementToHideSelector Le sélecteur de l'élement à cacher
 */
export const hideOnlyIfEscKey = (elementSelector, elementToHideSelector) => {
  const element = document.querySelector(elementSelector);
  const elementToHide = document.querySelector(elementToHideSelector);

  const keyListener = (event) => {
    if (event.code === 'Escape' && elementToHide.style.display !== 'none') {
      elementToHide.style.display = 'none';
    } else if (
      event.code !== 'Escape' &&
      elementToHide.style.display === 'none'
    ) {
      elementToHide.style.removeProperty('display');
    }
  };

  element.addEventListener('keyup', keyListener);
};
